import React, {
  useState,
  useCallback,
  useMemo,
  useRef,
  useEffect,
} from "react";
import DataGrid, {
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Scrolling,
  LoadPanel,
  SearchPanel,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnChooserSelection,
  Position,
  Paging,
  Pager,
  MasterDetail,
  Summary,
  TotalItem,
  StateStoring,
  Toolbar,
  Item,
} from "devextreme-react/data-grid";
import Button1 from "@material-ui/core/Button";
import Select from "react-select";
import TextField from "@material-ui/core/TextField";
import { MultiSelect } from "react-multi-select-component";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import { useStyles } from "../../Styles.js";
import CustomStore from "devextreme/data/custom_store";
import { useNavigate } from "react-router";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import axios from "axios";
import swal from "sweetalert";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CustomerMasterDetailView from "./CustomerMasterDetailView";
import useDeviceSize from "../../hooks/useDeviceSize";
import SalesPipelineComponent from "./SalesPipelineComponent";
import AddActivityModal from "../SaleActivity/AddActivityModal";
import { api_path } from "../../shared.js";
import CustomerSummaryPage from "./CustomerSummaryPage";
export function CustomerDataGridHead(props) {
  // onLoadingChanged => ควบคุม LoadPanel
  const onLoadingChanged = useCallback((e) => {
    setLoadPanelEnabled(!!e.isLoading);
  }, []);
  const [selectedStage, setSelectedStage] = useState(null);
  const gridRef = useRef(null);
  const onContentReady = useCallback(() => {
    setLoadPanelEnabled(false);
  }, []);
  const [width, height] = useDeviceSize();
  const [loadPanelEnabled, setLoadPanelEnabled] = useState(false); // default false
  const [modeSize] = useState("widget");
  const classes = useStyles();
  const navigate = useNavigate();
  const [getLoadGrid, setLoadGrid] = useState();

  const [getUserRole, setGetUserRole] = useState(
    String(props.USER_ROLE ?? "").trim()
  );
  useEffect(() => {
    setGetUserRole(String(props.USER_ROLE ?? "").trim());
  }, [props.USER_ROLE]);

  const [getUserEmail] = useState(props.getUserEMail);
  const [getUserID] = useState(props.CRM_ID);
  const [getEmpID] = useState(props.EMP_CODE);

  const [GET_SMF_CODE, SET_SMF_CODE] = useState("");
  const [GET_CUSTOMER_NAME, SET_CUSTOMER_NAME] = useState("");
  const [GET_TAXID, SET_TAXID] = useState("");
  const [getStatus, setStatus] = useState([]);
  const [selectStatus, setSelectStatus] = useState([]);
  const [getTeam, setTeam] = useState([]);

  const [getSelectTeam, setSelectTeam] = useState([]);
  const [getType, setType] = useState([]);
  const [selectType, setSelectType] = useState([]);
  const [getTag, setTag] = useState([]);
  const [tagList, setTagList] = useState([]);
  const [selectTag, setSelectTag] = useState([]);
  const [getSale, setSale] = useState([]);
  const [saleList, setSaleList] = useState([]);
  const [getSelectSale, setSelectSale] = useState([]);
  const pageSizes = [25, 50, 100];
  const token = process.env.REACT_APP_API_TOKEN;
  // ใช้ ref เก็บ AbortController ของ request ปัจจุบัน เพื่อยกเลิกเมื่อมี request ใหม่
  const currentRequestRef = useRef(null);

  const customerDataSource = useMemo(() => {
    return new CustomStore({
      key: "CRM_CUSCODE",
      load: async (loadOptions) => {
        // ยกเลิก request ก่อนหน้า (ถ้ามี)
        if (currentRequestRef.current) {
          try {
            currentRequestRef.current.abort();
          } catch (e) {}
        }
        const controller = new AbortController();
        currentRequestRef.current = controller;

        const skip = loadOptions.skip ?? 0;
        const take = loadOptions.take ?? 8000;
        const pageNumber = Math.floor(skip / take) + 1;

        const sortField = loadOptions.sort?.[0]?.selector ?? "CREATE_DATE";
        const sortOrder =
          loadOptions.sort?.[0]?.desc !== false ? "DESC" : "ASC";

        const params = new URLSearchParams({
          SALES_CODE: getSelectSale || "",
          CRM_UID: getUserID || "",
          SMF_CUSCODE: GET_SMF_CODE || "",
          CUSTOMER_NAME: GET_CUSTOMER_NAME || "",
          TAX_ID: GET_TAXID || "",
          CUSTOMER_STATUS: selectedStage || selectStatus || "",
          CUSTOMER_TYPE: selectType || "",
          CUSTOMER_BU: selectTag || "",
          SALES_TEAM: getSelectTeam || "",
          SALES_ROLE: getUserRole || "",
          load: getLoadGrid || "",
          skip,
          take,
          sortField,
          sortOrder,
        }).toString();

        const url = `${api_path}/customer/customers-paging.php?${params}`;

        try {
          const response = await fetch(url, {
            headers: { Authorization: `Bearer ${token}` },
            signal: controller.signal,
          });
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
          }
          const result = await response.json();

          const cleanData = (result.data ?? []).map((item) => ({
            ...item,
            CUSTOMER_NAME: item.CUSTOMER_NAME?.trim() || "(ไม่มีข้อมูล)",
            TAX_ID: item.TAX_ID?.trim() || "(ไม่มีข้อมูล)",
          }));

          return {
            data: cleanData,
            totalCount: result.totalCount ?? 0,
          };
        } catch (err) {
          if (err.name === "AbortError") {
            // ถูกยกเลิก — ให้ DataGrid รู้ว่าไม่มีข้อมูล (หรือ throw เพื่อบอก error)
            return { data: [], totalCount: 0 };
          }
          console.error("Error loading customers:", err);
          throw err;
        } finally {
          // clear ref
          if (currentRequestRef.current === controller) {
            currentRequestRef.current = null;
          }
        }
      },
    });
    // ใส่ deps เฉพาะค่าที่เปลี่ยนและส่งผลต่อ query
    // (อย่าใส่ token หรือ getEmpID ถ้าไม่เปลี่ยน)
  }, [
    getUserID,
    getUserRole,
    GET_SMF_CODE,
    GET_CUSTOMER_NAME,
    GET_TAXID,
    selectStatus,
    selectType,
    selectTag,
    getLoadGrid,
    selectedStage,
    getSelectSale,
    getSelectTeam,
  ]);

  const cellPrepared = (e) => {
    if (e.rowType !== "data") return;
    const yesNoIcon = (val) => (val ? "✔️" : "❌");
    const field = e.column.dataField;
    const rowData = e.data; // ข้อมูลทั้งแถว
    const smfCode = rowData.SMF_CUSCODE;
    if (field === "CUSTOMER_STATUS_EN") {
      e.cellElement.innerHTML = `<span class='status-button badge badge-status-${e.data[
        field
      ]
        .toLowerCase()
        .replace(/[\s()]/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "")}'><a href='Customer?customer_id=${
        e.row.key
      }&code=${smfCode}' target='_blank' style='color: #fff;'>${
        e.data[field]
      }</a></span>`;
    }
    if (field === "CUSTOMER_TYPE_EN") {
      e.cellElement.innerHTML = `<span class='status-button badge badge-type-${e.data[
        field
      ]
        .toLowerCase()
        .replace(/[\s()]/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "")}'><a href='Customer?customer_id=${
        e.row.key
      }&code=${smfCode}' target='_blank' style='color: #fff;'>${
        e.data[field]
      }</a></span>`;
    }
    if (field === "CUSTOMER_NAME") {
      e.cellElement.innerHTML =
        "<span class='status-button badge'><a href='Customer?customer_id=" +
        e.row.key +
        "' class='' title='View' target='_blank'>" +
        e.data[field] +
        "</a></span>";
    }
  };

  const onExporting = () => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");

    exportDataGrid({
      component: gridRef.current.instance, // ✅ ใช้ instance ของ DataGrid
      worksheet: worksheet,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "Customers.xlsx",
        );
      });
    });
  };
  // memoize lists เพื่อไม่ให้ recreate ทุก render
  const statusList = useMemo(
    () => [
      { value: "1", label: "Lead" },
      { value: "2", label: "In Contact" },
      { value: "3", label: "Quotation Sent" },
      { value: "6", label: "Close-Won" },
      { value: "7", label: "Close-Lost" },
    ],
    [],
  );
  const typeList = useMemo(
    () => [
      { value: "1", label: "Shipper" },
      { value: "2", label: "Consignee" },
      { value: "3", label: "Co-Load" },
      { value: "4", label: "Agent" },
    ],
    [],
  );
  const teamList = useMemo(
    () => [
      { value: "1", label: "Port Vanguard" },
      { value: "2", label: "Rail Breaker" },
    ],
    [],
  );
  const buList = useMemo(
    () => [
      { value: "AIR", label: "AIR" },
      { value: "FOOD", label: "FOOD" },
      { value: "TIRE", label: "TIRE" },
      { value: "REEFER", label: "REEFER" },
      { value: "ISOTANK", label: "ISOTANK" },
      { value: "SOC", label: "SOC" },
      { value: "WORLDWIDE", label: "WORLDWIDE" },
      { value: "SALES", label: "SALES" },
      { value: "SEA TP", label: "SEA TP" },
      { value: "SEA NON-TP", label: "SEA NON TP" },
      { value: "IMPORT", label: "IMPORT" },
      { value: "LCL", label: "LCL" },
    ],
    [],
  );
  const handleStatusChange = (obj) => {
    setSelectStatus(obj.value);
    setStatus({ value: obj.value, label: obj.label });
  };
  const handleTypeChange = (obj) => {
    setSelectType(obj.value);
    setType({ value: obj.value, label: obj.label });
  };
  const handleTeamChange = (obj) => {
    setSelectTeam(obj.value);
    setTeam({ value: obj.value, label: obj.label });
    setSale([]);
    setSelectSale([]);
    setSelectedStage([]);
  };
  const handleTagChange = (obj) => {
    setSelectTag(Array.isArray(obj) ? obj.map((x) => x.value).join("|") : []);
    setTag({
      value: obj.value,
      label: obj.label,
    });
  };
  const [resetSignal, setResetSignal] = useState(false);
  const handleClearInputClick = () => {
    setStatus([]);
    setSelectStatus([]);
    setTag([]);
    setSelectTag([]);
    setType([]);
    setSelectType([]);
    setSelectedStage(null);
    setResetSignal((prev) => !prev); // toggle เพื่อ trigger useEffect ใน child
    setTeam([]);
    setSelectTeam([]);
  };

  const handleAddButtonClick = () => {
    window.open("/s-crm/Customer", "_blank");
  };
  const columnChooserModes = [
    {
      key: "dragAndDrop",
      name: "Drag and drop",
    },
    {
      key: "select",
      name: "Select",
    },
  ];
  const searchEditorOptions = { placeholder: "Search column" };
  //Column Chooser
  const [mode, setMode] = React.useState(columnChooserModes[1].key);
  const [searchEnabled, setSearchEnabled] = React.useState(true);
  const [allowSelectAll, setAllowSelectAll] = React.useState(true);
  const [selectByClick, setSelectByClick] = React.useState(true);
  const [recursive, setRecursive] = React.useState(true);
  const isDragMode = mode === columnChooserModes[0].key;
  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  const onEditButtonClick = (rowData) => {
    const url = `/s-crm/customer?customer_id=${rowData.CRM_CUSCODE}&code=${rowData.SMF_CUSCODE}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const onActivityButtonClick = (rowData) => {
    setSelectedRow(rowData.CRM_CUSCODE);
    setShowModal(true);
  };
  const onCommentButtonClick = (rowData) => {
    // 1) เปิดหน้า customer ก่อนเลย
    const url = `/s-crm/customer?customer_id=${rowData.CRM_CUSCODE}`;
    window.open(url, "_blank", "noopener,noreferrer");

    // 2) ยิง API update is_read แบบ async
    fetch(api_path + "/customer/update-isread.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        sales_activity_item_id: rowData.SALES_ACTIVITY_ITEM_ID,
        is_read: 1,
      }),
    })
      .then(() => {
        // ✅ reload datagrid ใหม่
        if (gridRef.current) {
          gridRef.current.instance.refresh();
        }
      })
      .catch((error) => console.error("Error updating IS_READ:", error));
  };

  const onRefreshClick = () => {
    setLoadGrid(Math.random());
  };
  const handleRefreshGrid = () => {
    setLoadGrid(Math.random());
  };
  useEffect(() => {
    if (getUserRole == 1) {
      fetchSale();
      setSelectSale(getEmpID);
      setSale({
        SALE_NAME: getUserEmail,
      });
      // setSelectSale(getEmpID);
      // setSale({
      //   SALE_CODE: getEmpID,
      //   SALE_NAME: getUserID,
      // });
    } else {
      fetchSale();
    }
  }, []);
  const fetchSale = async () => {
    try {
      const response = await axios.get(
        `${api_path}/GET_SALES.php?empcode=yes`,
        {
          params: {
            role: getUserRole,
            user: getUserID,
          },
        },
      );

      const saleData = response.data;
      setSaleList(saleData);
      // ✅ 1. ถ้ามีตัวเลือกเดียว ให้ตั้งค่าทันที
      if (saleData.length === 1) {
        setSelectSale(saleData[0].SALE_CODE);
        setSale({
          SALE_CODE: saleData[0].SALE_CODE,
          SALE_NAME: saleData[0].SALE_NAME,
        });
        return; // จบเลยไม่ต้องเช็คต่อ
      }

      // ✅ 2. ถ้ามี currentID (ผู้ใช้ล็อกอิน) ให้ตั้งเป็น default
      // const currentSale = saleData.find((item) => item.SALE_CODE === getEmpID);
      // if (currentSale) {
      //   console.log("current sales");
      //   console.log(currentSale.SALE_CODE + getUserID);
      //   setSelectSale(currentSale.SALE_CODE);
      //   setSale({
      //     SALE_CODE: currentSale.SALE_CODE,
      //     SALE_NAME: currentSale.SALE_NAME,
      //   });
      // }
    } catch (error) {
      console.error("Error fetching sales data:", error);
    }
  };

  const handleSaleChange = (obj) => {
    if (obj) {
      setSelectSale(obj.SALE_CODE);
      setSale({ SALE_CODE: obj.SALE_CODE, SALE_NAME: obj.SALE_NAME });
    } else {
      setSelectSale([]);
      setSale([]);
    }
    // setTeam([]);
    // setSelectTeam([]);

    //setSelectedStage([]);
  };
  // 👇 สร้าง mapping ระหว่าง stageName → stageId
  const stageMapping = {
    lead: 1,
    "in contact": 2,
    "quotation sent": 3,
    negotiation: 5,
    "closed - won": 6,
    "closed - lost": 7,
  };
  const handleStageClick = (stageName) => {
    const key = stageName.trim().toLowerCase(); // 👈 normalize
    const stageId = stageMapping[key] || null;
    //console.log("🟦 Stage selected:", stageId);
    setSelectedStage(stageId);
  };
  const allowedRoles = ["3", "7", "8", "9", "14"]; // ใส่ role_id ที่อนุญาต
  // console.log("getUserRole:", getUserRole, typeof getUserRole);
  if (!getUserRole) return null; // 👈 อย่า render grid ถ้ายังไม่มี role
  const isAllowed = allowedRoles.includes(getUserRole);
  const gridSize = isAllowed ? 8 : 12;
  const onDeleteButtonClick = (rowData) => {
    swal({
      title: "Are you sure?",
      text: "You want to delete this data?",
      icon: "warning",
      dangerMode: true,
      buttons: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteRow(rowData.CRM_CUSCODE);
      }
    });
  };

  const deleteRow = async (id) => {
    try {
      const response = await axios.delete(
        `${api_path}/customer/customers.php?id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setLoadGrid(Math.floor(Math.random() * 20) + 1);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Container maxWidth="xl">
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <br />
        </Grid>
        <Grid item xs={12} sm={8}>
          <label className="head">Customer Management</label>
          <AddActivityModal
            key={selectedRow} // 👈 ทำให้ modal รีเซ็ตทุกครั้งที่เลือกแถวใหม่
            show={showModal}
            onClose={() => setShowModal(false)}
            CUSTOMER_CODE={selectedRow}
            ROLE_ID={getUserRole}
            PAGE="GRID"
            onSaveSuccess={handleRefreshGrid} // ✅ ส่ง callback
          />
        </Grid>
        <Grid item xs={12} sm={2}></Grid>
        <Grid item xs={12} sm={2} style={{ display: "flex" }}>
          {/* <AddCustomerModal /> */}
          <Button1
            className="addBtn"
            type="button"
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleAddButtonClick}
          >
            New Customer/Check Duplicate
          </Button1>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={2}>
          <label>SMF CODE</label>
          <TextField
            size="small"
            name="GET_SMF_CODE"
            variant="outlined"
            fullWidth
            id="GET_SMF_CODE"
            value={GET_SMF_CODE}
            onChange={(e) => SET_SMF_CODE(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Customer</label>
          <TextField
            size="small"
            name="GET_CUSTOMER_NAME"
            variant="outlined"
            fullWidth
            id="GET_CUSTOMER_NAME"
            value={GET_CUSTOMER_NAME}
            onChange={(e) => SET_CUSTOMER_NAME(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>TAX ID</label>
          <TextField
            size="small"
            name="GET_TAXID"
            variant="outlined"
            fullWidth
            id="GET_TAXID"
            value={GET_TAXID}
            onChange={(e) => SET_TAXID(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>STAGE</label>
          <Select
            defaultValue={"-"}
            className="multiselect1"
            placeholder="Select..."
            value={getStatus}
            options={statusList}
            onChange={handleStatusChange}
            getOptionLabel={(x) => x.label}
            getOptionValue={(x) => x.value}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>TYPE</label>
          <Select
            defaultValue={"-"}
            className="multiselect2"
            placeholder="Select..."
            value={getType}
            options={typeList}
            onChange={handleTypeChange}
            getOptionLabel={(x) => x.label}
            getOptionValue={(x) => x.value}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>BU</label>
          <MultiSelect
            className="multiselect3"
            options={buList}
            value={buList.filter((obj) => selectTag.includes(obj.value))}
            onChange={handleTagChange}
            labelledBy="Select"
            hasSelectAll={false}
          />
        </Grid>

        {/* {allowedRoles.includes(getUserRole) ? (
          <Grid item xs={12} sm={2}>
            <label>TEAM</label>
            <Select
              defaultValue={"-"}
              className="multiselect4"
              placeholder="Select..."
              value={getTeam}
              options={teamList}
              onChange={handleTeamChange}
              getOptionLabel={(x) => x.label}
              getOptionValue={(x) => x.value}
            />
          </Grid>
        ) : (
          // โชว์กรณี role ไม่อยู่ใน allowedRoles
          <Grid item xs={12} sm={2}></Grid>
        )} */}

        <Grid item xs={12} sm={2}>
          <label>SALES</label>
          <Select
            defaultValue={"-"}
            className="multiselect5"
            placeholder="Select..."
            value={getSale}
            options={saleList}
            onChange={handleSaleChange}
            getOptionLabel={(x) => x.SALE_NAME}
            getOptionValue={(x) => x.SALE_CODE}
            required
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          &nbsp;
        </Grid>

        <Grid
          item
          xs={12}
          sm={4}
          // sm={gridSize}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <div className="paddingSearchButton">&nbsp;</div>
          <Button1
            className="searchButton"
            type="button"
            variant="contained"
            color="primary"
            //onClick={handleSearch}
          >
            Search
          </Button1>
          &nbsp;&nbsp;&nbsp;
          <Button1
            className="searchButton"
            type="button"
            variant="outlined"
            color="primary"
            onClick={handleClearInputClick}
          >
            Clear Filter
          </Button1>
          &nbsp;&nbsp;&nbsp;
          <Button1
            className="searchButton"
            type="button"
            variant="outlined"
            color="primary"
            onClick={onRefreshClick}
          >
            Refresh data
          </Button1>
        </Grid>
        <Grid item xs={12} sm={12}>
          <CustomerSummaryPage
            onStageClick={handleStageClick}
            userId={getUserID}
            empCode={getEmpID}
            salesId={getSelectSale}
            salesTeam={getSelectTeam}
            salesRole={getUserRole}
          />
        </Grid>
      </Grid>

      <Grid container className={classes.root}>
        <DataGrid
          key={getUserRole} // 👈 บังคับสร้าง DataGrid ใหม่เมื่อ role เปลี่ยน
          id="customerContainer"
          onCellPrepared={cellPrepared}
          dataSource={customerDataSource}
          showBorders={true}
          columnAutoWidth={true}
          rowAlternationEnabled={false}
          allowColumnReordering={true}
          allowColumnResizing={true}
          columnResizingMode={modeSize}
          columnMinWidth={50}
          showScrollbar={true}
          keyExpr="CRM_CUSCODE"
          onExporting={onExporting}
          ref={gridRef}
          onContentReady={onContentReady}
          height={height}
          repaintChangesOnly={true}
          hoverStateEnabled={true}
          // remoteOperations={true} // <<< สำคัญ: ให้ server handle paging/sort/filter ** ทำไมมีบรรทัดนี้แล้วทำให้ search ใน datagrid ไม่ได้
          //onLoadingChanged={onLoadingChanged} // <<< ควบคุม LoadPanel state
        >
          <Scrolling
            rowRenderingMode="virtual"
            showScrollbar="always"
            useNative="false"
            scrollByThumb="true"
          ></Scrolling>
          <StateStoring
            enabled={true}
            type="localStorage"
            storageKey="storageCustomer"
          />
          <MasterDetail enabled={true} component={CustomerMasterDetailView} />
          {/* <MasterDetail enabled={true} render={renderDetailSection} /> */}
          <FilterRow visible={true} applyFilter="auto" />
          <FilterPanel visible={true} />
          <HeaderFilter visible={true} />
          <SearchPanel
            visible={true}
            width={240}
            placeholder="Full Text Search..."
          />
          <Column dataField="CRM_CUSCODE" caption="CRM Code" width={80} />
          <Column dataField="SMF_CUSCODE" caption="SMF Code" width={80} />
          <Column dataField="CUSTOMER_NAME" caption="Name" />
          <Column dataField="TAX_ID" caption="TAX ID" />
          <Column dataField="GLOBAL_TIER_EN" caption="Tier" />
          <Column dataField="CUSTOMER_STATUS_EN" caption="Stage" />
          <Column dataField="CUSTOMER_TYPE_EN" caption="Type" />
          <Column dataField="CUSTOMER_BU" caption="Tag" />
          <Column dataField="DECISION_MAKER" caption="Decision Maker" />
          <Column dataField="CAMPAIGN_NAME" caption="Campaign" />
          <Column dataField="ACTIVE_STATUS" caption="ACTIVE" visible={false} />
          <Column
            dataField="CUSTOMER_PROVINCE"
            caption="Province"
            visible={false}
          />
          <Column dataField="NOTE1" caption="Note" visible={false} />
          <Column
            dataField="SALES_NAME"
            caption="Sales"
            visible={allowedRoles.includes(getUserRole)} // 👈 แค่ควบคุมการแสดง
          />
          <Column
            dataField="CREATE_DATE"
            caption="Create Date"
            dataType="date"
            format="dd-MMM-yyyy"
            groupInterval="day"
          ></Column>
          <Column
            dataField="LASTUPDATE"
            caption="Last Update"
            dataType="date"
            format="dd-MMM-yyyy HH:mm"
            groupInterval="day"
          ></Column>
          <Column
            dataField="HAS_FOLLOW_UP"
            caption="Follow-up"
            width={100}
            alignment="center" // ✅ จัด icon ให้อยู่ตรงกลาง
            cellRender={(cellData) => {
              const value = cellData.value;
              return value == 1 ? (
                <CheckCircleOutlineIcon style={{ color: "green" }} />
              ) : (
                <CancelOutlinedIcon style={{ color: "red" }} />
              );
            }}
          />
          <Column
            caption="Edit"
            width={50}
            alignment="center"
            cellRender={(cellData) => {
              return (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <button
                    style={{
                      backgroundColor: "GRAY",
                      color: "white",
                      border: "none",
                      padding: "5px 10px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    title="Edit Customer"
                    onClick={() => onEditButtonClick(cellData.data)}
                  >
                    <span
                      className="dx-icon dx-icon-edit"
                      style={{ fontSize: "12px" }}
                    ></span>
                  </button>
                </div>
              );
            }}
          />
          <Column
            caption="Actitity"
            width={50}
            alignment="center"
            cellRender={(cellData) => {
              return (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <button
                    style={{
                      backgroundColor: "#007bff",
                      color: "white",
                      border: "none",
                      padding: "5px 10px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    title="Add Activity"
                    onClick={() => onActivityButtonClick(cellData.data)}
                  >
                    <span
                      className="dx-icon dx-icon-plus"
                      style={{ fontSize: "12px" }}
                    ></span>
                  </button>
                </div>
              );
            }}
          />
          <Column
            caption="Del"
            width={50}
            alignment="center"
            cellRender={(cellData) => {
              //const isStatusOK = cellData.data.CAMPAIGN_STATUS === "0";
              const isRoleOK = props.USER_ROLE == 7 || props.USER_ROLE == 14;

              // if (!(isStatusOK && isRoleOK)) {

              if (!isRoleOK) {
                return null; // ❌ ไม่ต้องโชว์อะไรเลย
              }

              return (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <button
                    style={{
                      backgroundColor: "#F44336",
                      color: "white",
                      border: "none",
                      padding: "5px 10px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    title="Delete"
                    onClick={() => onDeleteButtonClick(cellData.data)}
                  >
                    <span
                      className="dx-icon dx-icon-trash"
                      style={{ fontSize: "12px" }}
                    ></span>
                  </button>
                </div>
              );
            }}
          />
          {/* <Column
            caption="Comment"
            width={50}
            alignment="center"
            cellRender={(cellData) => {
              const isUnread = cellData.data.IS_READ == 0;
              if (!isUnread) {
                // ถ้าอ่านแล้ว ไม่ต้องแสดงปุ่ม
                return null;
              }

              return (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <button
                    style={{
                      backgroundColor: "#007bff",
                      color: "white",
                      border: "none",
                      padding: "5px 10px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    title="View Comment"
                    onClick={() => onCommentButtonClick(cellData.data)}
                  >
                    <span
                      className="dx-icon dx-icon-comment"
                      style={{ fontSize: "16px" }}
                    ></span>
                  </button>
                </div>
              );
            }}
          /> */}
          <ColumnChooser enabled={true} mode={mode}>
            <Position
              my="right top"
              at="right bottom"
              of=".dx-datagrid-column-chooser-button"
            />

            <ColumnChooserSearch
              enabled={searchEnabled}
              editorOptions={searchEditorOptions}
            />

            <ColumnChooserSelection
              allowSelectAll={allowSelectAll}
              selectByClick={selectByClick}
              recursive={recursive}
            />
          </ColumnChooser>
          <LoadPanel enabled={true} /> {/* ผูกกับ state จริง */}
          <Export enabled={true} allowExportSelectedData={true} />
          <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
          <Paging defaultPageSize={25} />
          <Summary>
            <TotalItem
              column="CRM_CUSCODE"
              summaryType="count"
              valueFormat={{ type: "fixedPoint", precision: 0 }} // รวมเป็น sum, มี comma
              displayFormat="Total: {0}"
            />
          </Summary>
        </DataGrid>
      </Grid>
    </Container>
  );
}
